/** Wire values and timings of the shared event transport; the standalone worker mirrors them in eventStream.worker.js. */
export const STARTUP_SCOPE = "anonymous-startup";
export const TRANSPORT_EVENT_PREFIX = "mq.transport.";
export const TRANSPORT_EVENT_RECONNECTING = `${TRANSPORT_EVENT_PREFIX}reconnecting`;
export const TRANSPORT_EVENT_RECONNECTED = `${TRANSPORT_EVENT_PREFIX}reconnected`;
export const INITIAL_RETRY_MS = 1000;
export const MAX_RETRY_MS = 30000;
export const RETRY_BACKOFF_FACTOR = 2;
export const WORKER_HANDSHAKE_TIMEOUT_MS = 3000;
export const FRAME_TERMINATOR_LENGTH = 2;
export const HTTP_OK = 200;
export const HTTP_SERVICE_UNAVAILABLE = 503;

export type WorkerMessageType = "ping" | "accepted" | "response" | "chunk" | "reconnecting" | "reconnected" | "end";
